import React from "react";
import UrlInput from "../../../../../../../shared/components/ui/urlInput/UrlInput";
import classes from "./UrlRow.module.css";

const UrlRow = ({ imageLink, onImageLinkChange, label, placeholder }) => {
    return (
        <div className={classes.UrlRow}>
            <UrlInput
                value={imageLink}
                onChange={onImageLinkChange}
                placeholder={placeholder}
            />
            <span className={classes.UrlLabel}>{label}</span>
        </div>
    );
};

export default UrlRow;
